import { getDelayAction } from 'automaton/actions/DelayAction'
import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestRespinAction } from 'automaton/actions/RequestRespinAction'
import { getRespinIntroAction } from 'automaton/actions/RespinIntroAction'
import { getBetState } from 'automaton/states/BetState'
import { getFreebetAddState } from 'automaton/states/FreebetAddState'
import { getFreespinAddState } from 'automaton/states/FreespinsAddState'
import { getWinState } from 'automaton/states/WinState'

import { getFreeBetState } from './FreeBetState'

export function getRespinState() {
  const winModel = game.models.WinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const spinModel = game.models.SpinModel.get()
  const freeBetModel = game.models.FreebetsModel.get()

  const name = 'RESPIN'
  const actions = [
    getRespinIntroAction(),
    getRequestRespinAction(),
    game.models.GameModel.requestAgainAllowed
      ? getDelayAction(0.1)
      : getReelSpinAction(),
  ]
  const transition = () =>
    game.models.GameModel.requestAgainAllowed
      ? getBetState()
      : winModel.winLines.length
        ? getWinState()
        : spinModel.respin.length
          ? getRespinState()
          : freespinModel.left
            ? getFreespinAddState(false)
            : freeBetModel.add
              ? getFreebetAddState()
              : freeBetModel.rest
                ? getFreeBetState()
                : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
